export default __webpack_public_path__ + "static/Cannon-619f27be78aab3c8fb4158620defdad7.png";